import React from "react";

export const InputText = (props) => {
    const data = props.data;
	return (
		<input
			type="text"
			value={data.value || ""}
			placeholder={data.ref.includes("gps") ? "0.00000, 0.000000" : ""}
			onChange={(e) => data.onChange(e.target.value, data.ref)}
			maxLength={data?.maxL || ""}
		/>
	);
};

export const InputDate = (props) => {
	const data = props.data;
	return (
		<input
			type="date"
			value={data.value || ""}
			onChange={(e) => data.onChange(e.target.value, data.ref)}
		/>
	);
};

export const InputNum = (props) => {
	const data = props.data;
	return (
		<input
			type="number"
			value={data.value || (data.value === 0 ? 0 : "")}
			min={data.min}
			step={data.step}
			placeholder={data.place}
			onChange={(e) => data.onChange(e.target.value, data.ref)}
		/>
	);
};

export const Must = () => {
    return <span style={{ fontStyle: "italic", color: "red" }}>(*)</span>;
}
   